var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgModels = function SvgModels(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.93412 5.62846C7.82623 6.13461 7.59068 6.59351 7.26279 6.96984L9.066 7.87145C9.17391 7.3653 9.40947 6.90641 9.73738 6.53009L7.93412 5.62846Z",
    fill: "#262626"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2627 6.53006C14.5906 6.90637 14.8262 7.36526 14.9341 7.87141L16.7373 6.96981C16.4094 6.59348 16.1739 6.13458 16.066 5.62842L14.2627 6.53006Z",
    fill: "#262626"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.934 9.12878C14.8261 9.63492 14.5905 10.0938 14.2626 10.4701L16.0659 11.372C16.1737 10.8658 16.4092 10.4069 16.737 10.0305L14.934 9.12878Z",
    fill: "#262626"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7377 13.9702C16.4097 13.594 16.1741 13.1351 16.0661 12.629L14.2629 13.5303C14.5908 13.9067 14.8263 14.3656 14.9342 14.8717L16.7377 13.9702Z",
    fill: "#262626"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9341 16.1285C14.8262 16.6346 14.5907 17.0935 14.2628 17.4698L16.066 18.3714C16.1739 17.8653 16.4095 17.4064 16.7374 17.0301L14.9341 16.1285Z",
    fill: "#262626"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.73728 17.4698C9.40939 17.0935 9.17385 16.6346 9.06597 16.1284L7.2627 17.0301C7.59061 17.4064 7.82618 17.8653 7.93409 18.3714L9.73728 17.4698Z",
    fill: "#262626"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M9.066 14.8714C9.17391 14.3653 9.40947 13.9064 9.73738 13.5301L7.93412 12.6285C7.82623 13.1346 7.59068 13.5935 7.26279 13.9698L9.066 14.8714Z",
    fill: "#262626"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M7.2627 10.0301C7.59061 10.4064 7.82618 10.8653 7.93409 11.3714L9.73728 10.4698C9.40939 10.0935 9.17385 9.63458 9.06597 9.12842L7.2627 10.0301Z",
    fill: "#262626"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M7 5C7 6.10457 6.10457 7 5 7C3.89543 7 3 6.10457 3 5C3 3.89543 3.89543 3 5 3C6.10457 3 7 3.89543 7 5Z",
    fill: "#262626"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M14 8.5C14 9.60457 13.1046 10.5 12 10.5C10.8954 10.5 10 9.60457 10 8.5C10 7.39543 10.8954 6.5 12 6.5C13.1046 6.5 14 7.39543 14 8.5Z",
    fill: "#262626"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M21 5C21 6.10457 20.1046 7 19 7C17.8954 7 17 6.10457 17 5C17 3.89543 17.8954 3 19 3C20.1046 3 21 3.89543 21 5Z",
    fill: "#262626"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M7 12C7 13.1046 6.10457 14 5 14C3.89543 14 3 13.1046 3 12C3 10.8954 3.89543 10 5 10C6.10457 10 7 10.8954 7 12Z",
    fill: "#262626"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M21 12C21 13.1046 20.1046 14 19 14C17.8954 14 17 13.1046 17 12C17 10.8954 17.8954 10 19 10C20.1046 10 21 10.8954 21 12Z",
    fill: "#262626"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M14 15.5C14 16.6046 13.1046 17.5 12 17.5C10.8954 17.5 10 16.6046 10 15.5C10 14.3954 10.8954 13.5 12 13.5C13.1046 13.5 14 14.3954 14 15.5Z",
    fill: "#262626"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M7 19C7 20.1046 6.10457 21 5 21C3.89543 21 3 20.1046 3 19C3 17.8954 3.89543 17 5 17C6.10457 17 7 17.8954 7 19Z",
    fill: "#262626"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M21 19C21 20.1046 20.1046 21 19 21C17.8954 21 17 20.1046 17 19C17 17.8954 17.8954 17 19 17C20.1046 17 21 17.8954 21 19Z",
    fill: "#262626"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgModels);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "models.f40b7d592b73303c11b2a092a28ae6c4.svg";